import clsx from 'clsx';

import './listings.css';

export const ListingCardSkeleton = ({ className }: { className?: string }) => {
  return (
    <div
      className={clsx('listing-card', className)}
      data-testid="listing-card-skeleton"
      aria-hidden="true"
    >
      <div className="image-cover relative">
        <div className="h-[15rem] w-full animate-pulse rounded-xl bg-gray-200" />
      </div>
      <div className="listing-card-content">
        <div className="card-title">
          <div className="h-3 w-[40%] max-w-[6rem] animate-pulse rounded bg-gray-200" />
          <div className="mt-1.5 h-5 w-[75%] max-w-[14rem] animate-pulse rounded bg-gray-200" />
        </div>
        <div className="card-content">
          <div className="flex flex-col gap-[0.25rem]">
            <div className="h-4 w-[60%] max-w-[10rem] animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-[45%] max-w-[8rem] animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="listing-rate">
          <div className="h-6 w-[40%] max-w-[8rem] animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </div>
  );
};
